import { randomUUID } from './uuid';

const DEVICE_ID_KEY = 'gp_device_id';

export interface DeviceInfo {
  device_id: string;
  platform: 'web' | 'ios_web' | 'android_web';
  os: string;
  language: string;
  timezone: string;
  screen_width: number;
  screen_height: number;
  user_agent: string;
  brand: string | null;
  device_model: string | null;
}

function detectPlatform(): DeviceInfo['platform'] {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios_web';
  if (/Android/i.test(ua)) return 'android_web';
  return 'web';
}

function parseBrandModel(ua: string): { brand: string | null; device_model: string | null } {
  // iOS: iPhone / iPad / iPod
  const iosMatch = ua.match(/(iPhone|iPad|iPod)/);
  if (iosMatch) return { brand: 'Apple', device_model: iosMatch[1] };
  // Android UA format: "...Android X.X; <Manufacturer Model>)"
  const androidMatch = ua.match(/Android[^;]*;\s*([^)]+)\)/);
  if (androidMatch) {
    const deviceStr = androidMatch[1].trim();
    const brand = deviceStr.split(/\s+/)[0] || null;
    return { brand, device_model: deviceStr };
  }
  return { brand: null, device_model: null };
}

export function getDeviceInfo(): DeviceInfo {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  const ua = navigator.userAgent;
  const { brand, device_model } = parseBrandModel(ua);
  return {
    device_id: deviceId,
    platform: detectPlatform(),
    os: navigator.platform,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    user_agent: ua,
    brand,
    device_model,
  };
}
